import axios from 'axios';
import { apiUrl } from './index';

export default {
  getItems(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/payments`,
      params,
    });
  },
  updateItem({ id, discount }) {
    return axios({
      method: 'patch',
      url: `${apiUrl}/payments/${id}`,
      data: {
        discount,
      },
    });
  },
  getItem({ id }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/payments/${id}`,
    });
  },
  getStatuses() {
    return axios({
      method: 'get',
      url: `${apiUrl}/payments/statuses`,
    });
  },
};
